import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function ProofSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].proof;
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-teal-950 to-black" data-id="element-302">
      <div className="max-w-5xl mx-auto" data-id="element-303">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-8 text-yellow-400" data-id="element-304">
          {t.title}
        </h2>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-305">
          {t.badges.map((badge, index) => <div key={index} className="bg-gradient-to-br from-teal-900/50 to-black border border-teal-600/30 rounded-xl px-4 md:px-6 py-2 md:py-3" data-id="element-306">
              <p className="text-base md:text-lg text-teal-200" data-id="element-307">{badge}</p>
            </div>)}
        </div>
        <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-308">
          {t.testimonials.map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-teal-950/50 to-black border border-teal-700/30 rounded-xl p-4 md:p-6" data-id="element-309">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-310">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 text-yellow-400 fill-yellow-400" data-id="element-311" />)}
              </div>
              <p className="text-base md:text-lg italic text-gray-200 mb-3 md:mb-4" data-id="element-312">
                "{testimonial.quote}"
              </p>
              <p className="text-sm md:text-base text-teal-300 font-semibold" data-id="element-313">
                — {testimonial.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}